export default __webpack_public_path__ + "static/media/bg-login.ee1515ea.png";